import React, { useEffect } from 'react';

interface ValueChangeWatcherProps {
  onValueChange: () => void;
}

const ValueChangeWatcher: React.FC<ValueChangeWatcherProps> = ({ onValueChange }) => {
  useEffect(() => {
    const checkLocalStorageChange = () => {
      const currentStoredValue = sessionStorage.getItem('@AXS-success');
      if (currentStoredValue !== previousStoredValue) {
        onValueChange();
        clearInterval(interval);
      }
      previousStoredValue = currentStoredValue;
    };

    let previousStoredValue = sessionStorage.getItem('@AXS-success');
    const interval = setInterval(checkLocalStorageChange, 500);

    return () => {
      clearInterval(interval);
    };
  }, [onValueChange]);

  return <></>;
};

export default ValueChangeWatcher;
